
import { Box, Paper, Typography } from '@mui/material';
import { Ico_ExclamationMark, Ico_Correct, Ico_Incorrect } from '@sagecentral/core-ui';
import { useTaskContext } from 'hooks/tasks';

const TaskRequirementsBox = () => {
    const taskContext = useTaskContext();
    const { task } = taskContext;

    if(task?.isProblem === null && task?.requirements?.length === 0)
    {
        return null;        
    }

    return (
        <Box>
            <Paper elevation={3} >
                <Box sx={{ padding: '16px' }}>
                    <Box sx={{ paddingBottom: '16px' }}>{task?.requirements?.some(req => req.isDone === false) || task?.isProblem ? <Ico_ExclamationMark sx={{ width: '40px', height: '40px', fill: '#EB0000' }} /> : <Ico_Correct sx={{ width: '40px', height: '40px', stroke: '#008929' }} />}</Box>
                    <Box sx={{ paddingBottom: '16px', fontWeight: 600 }}>Required to complete the task:</Box>
                    <Box sx={{ fontSize: '14px', display: 'grid', gap: '12px' }}>
                        {task &&
                            <Box>                                
                                <Box sx={{ display: 'flex', alignItems: 'top' }}>
                                    {task.isProblem !== null && task.isProblem &&
                                        <>
                                            <Ico_Incorrect sx={{ height: '20px', width: '20px',  stroke: '#EB0000' }} />
                                            <Typography sx={{ pl: '8px', color: '#888888' }}> Resolve active problem flag</Typography>
                                        </> 
                                    }
                                    {task.isProblem !== null && !task.isProblem &&
                                        <>
                                            <Ico_Correct sx={{ height: '20px', width: '20px', stroke: '#008929' }} />
                                            <Typography sx={{ pl: '8px', color: 'black' }}> Resolve active problem flag</Typography>
                                        </>
                                    }
                                
                                </Box>
                                {task?.requirements?.map((req, index) => (
                                    <Box sx={{ display: 'flex', alignItems: 'top' }}>
                                        {req.isDone ? <Ico_Correct sx={{ height: '20px', width: '20px', stroke: '#008929' }} /> : <Ico_Incorrect sx={{ height: '20px', width: '20px', stroke: '#EB0000' }} />}

                                        <Typography sx={{ pl: '8px', color: req.isDone ? 'black' : '#888888' }}>{`Add ${req.tabKey.charAt(0).toUpperCase() + req.tabKey.slice(1)}: ${req.description}`}</Typography>
                                    </Box>
                                ))}
                            </Box>
                        }
                    </Box>
                </Box>
            </Paper>
        </Box>
    )
}

export default TaskRequirementsBox;